import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {QueryComponent} from './query.component';
import {MatListModule, MatPaginatorModule, MatTableModule, MatTabsModule} from '@angular/material';
import {TextFieldModule} from '@angular/cdk/text-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MonacoEditorModule} from 'ngx-monaco-editor';
import {ApplicationPipesModule} from '../application-pipes-module/application-pipes.module';


@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        TextFieldModule,
        FormsModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatTableModule,
        MonacoEditorModule.forRoot(),
        MatPaginatorModule,
        MatListModule,
        ApplicationPipesModule,
    ],
  declarations: [QueryComponent],
  exports: [QueryComponent]
})
export class QueryModule {
}
